import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCerberus } from "../../hooks/useCerberus";
import Loading from "../Widgets/Loading";

/**
 * Guards the one-time registration flow. An account registers once, so a user who is already
 * registered has no business on /register — before this they could simply navigate back to it and
 * re-submit the form.
 *
 * It also removes a flash at the end of registration. Both registration pages call
 * `refreshUserData()` and then `navigate("/dashboard")`; in the gap between those, `isRegistered`
 * has flipped to true, so RootLayout swaps the bare registration shell for the full app shell
 * while the route is still /register — briefly drawing the app chrome around the registration form
 * the user has just completed. Redirecting the moment the flag flips means that intermediate state
 * never renders.
 */
const RequireUnregistered = ({ children }: { children: ReactNode }) => {
  const { loading, isRegistered } = useCerberus();

  if (loading) return <Loading />;

  return isRegistered ? <Navigate to="/dashboard" replace /> : children;
};

export default RequireUnregistered;
